import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {RestApi} from '../RestApi/restApi';
import {Router} from '@angular/router';

interface TestExecutionServiceInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}
@Injectable({
  providedIn: 'root'
})
export class TestExecutionService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router
  ) { }

  retrieveTestExecutions(testCycleMstrId) {

    return this.http.get<TestExecutionServiceInfo>(this.restAPI.RETRIEVETESTEXECUTIONS+"/"+testCycleMstrId, { headers: this.headers });

  }
  insertUpdateTestExecution(testExecutionData) {

    return this.http.post<TestExecutionServiceInfo>(this.restAPI.INSERTUPDATETESTEXECUTION,testExecutionData ,{ headers: this.headers });

  }
  deleteTestExecution(id) {
    return this.http.delete<TestExecutionServiceInfo>(this.restAPI.DELETETESTEXECUTION+"/"+id, { headers: this.headers });
  }

  retrieveTestExecutionByCycleMstrId(cycleMstrId) {

    return this.http.get<TestExecutionServiceInfo>(this.restAPI.RETRIEVETESTEXECUTIONBYCYCLEMSTRID+"/"+cycleMstrId, { headers: this.headers });

  }

  retrieveScriptsVersion(scriptId){
    return this.http.get<TestExecutionServiceInfo>(this.restAPI.RETRIEVE_SCRIPTS_VERSION+"/"+ scriptId,{ headers: this.headers })

  }
  /**
   * 
   * @param dnsId 
   * @param dnsName 
   * @param version 
   * @param scriptName 
   * @returns 
   * @ModifiedBy-Asha Waghadure
   * @ModifiedDate-20-11-2025
   * @Note-to get the document details using latest version
   */
    retrieveDocumentLatestVersion(dnsId,dnsName,version,scriptName){
    return this.http.get<TestExecutionServiceInfo>(this.restAPI.RETRIEVE_DOCUMENT_VERSION+"/"+ dnsId+"/"+dnsName+"/"+version+"/"+scriptName,{ headers: this.headers })

  }
  /**
   * 
   * @param dnsId 
   * @param dnsName 
   * @param scriptId 
   * @param scriptName 
   * @returns 
   * @ModifiedBy-Asha Waghadure
   * @ModifiedDate-20-11-2025
   * @Note-using to get the latest document version
   */
  retrieveDocumentVersion(dnsId,dnsName,scriptId,scriptName){
    return this.http.get<TestExecutionServiceInfo>(this.restAPI.RETRIEVE_DOCUMENTS_VERSION+"/"+ dnsId+"/"+dnsName+"/"+scriptId+"/"+scriptName,{ headers: this.headers })

  }
}
